import React from 'react';
var DefaultErrorMessage = function () {
    var redirectLink = 'https://access.redhat.com/support';
    var statusLink = 'https://status.redhat.com';
    return (React.createElement(React.Fragment, null,
        "If the problem persists, contact ",
        React.createElement("a", { href: redirectLink }, "Red Hat Support"),
        " or check our ",
        React.createElement("a", { href: statusLink }, " status page"),
        " for known outages."));
};
export default DefaultErrorMessage;
//# sourceMappingURL=DefaultErrorMessage.js.map